import { useQuery } from '@tanstack/react-query';
import { useApi } from '@/api/ApiContext';
import type { GetCategoryDetailsResponse } from '@/api/handlers/resources/categories/responses';
import type { ApiResponse } from '@/api/handlers/responses';
import { CategoryQueryKeys } from './categoryQueryKeys';

export const useCategoryDetailsQuery = (enabled = true) => {
    const { apiClient } = useApi();

    return useQuery<ApiResponse<GetCategoryDetailsResponse>>({
        queryKey: CategoryQueryKeys.details(),
        queryFn: () => apiClient.categories.getCategoryDetails(),
        enabled,
        staleTime: 60_000,
    });
};
